import { render, staticRenderFns } from "./TalkizyMeeting.vue?vue&type=template&id=0b6a98c7&scoped=true&"
import script from "./TalkizyMeeting.vue?vue&type=script&lang=js&"
export * from "./TalkizyMeeting.vue?vue&type=script&lang=js&"
import style0 from "./TalkizyMeeting.vue?vue&type=style&index=0&id=0b6a98c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6a98c7",
  null
  
)

export default component.exports